import React from 'react';
import Edge from './Edge.js';
import { Group, Rect, Line} from 'react-konva';

export default function MacroEdges({macroEdges, rack, setSelectedEdge, selectedEdge}) {
    let list = [];
    for (let i in rack.macros) {
        let macro = rack.macros[i];
        let edges = macroEdges[macro.id];
        if (edges === undefined) {
            continue;
        }
        list = [... list,
                ... edges.map(
                    edge =>
                        <Edge
                          rack={rack}
                          macro={macro}
                          edge={edge}
                          setSelectedEdge={setSelectedEdge}
                          selected={selectedEdge === edge}/>
                )];
    }

    return (
        <g>
          {list}
        </g>
    );
}
